import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class RegEntidadAuditoraItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: RegEntidadAuditoraItemViewModel[];
}

export class RegEntidadAuditoraItemViewModel {
    public Id: number;

    public Nombre = '';

    public Apellidos = '';

    public NIF = '';

    public RazonSocial = '';

    public NIFRazonSocial = '';

    public IdProvinciaRazonSocialDescripcion = '';

    public IdProvinciaRazonSocial: number | null;

    public CodigoPostalRazonSocial = '';

    public DireccionRazonSocial = '';

    public LocalidadRazonSocial = '';

    public NombrePersonaContacto = '';

    public ApellidosPersonaContacto = '';

    public EmailPersonaContacto = '';
}

export class FilterSearchingRegEntidadAuditoraViewModel extends FilterSearchingBaseViewModel {
    public Id: number;

    public Nombre = '';

    public Apellidos = '';

    public NIF = '';

    public RazonSocial = '';

    public NIFRazonSocial = '';

    public IdProvinciaRazonSocial: number;

    public LocalidadRazonSocial = '';

    public NombrePersonaContacto = '';

    public ApellidosPersonaContacto = '';

    public Activa: number = EnumSiNoTodos.TODOS;

    public IdCampania: number;
}

export class RegEntidadAuditoraViewModel {
    public Id: number;

    public Nombre = '';

    public Apellidos = '';

    public NIF = '';

    public RazonSocial = '';

    public NIFRazonSocial = '';

    public DireccionRazonSocial = '';

    public LocalidadRazonSocial = '';

    public IdProvinciaRazonSocial = '';

    public CodigoPostalRazonSocial = '';

    public NombrePersonaContacto = '';

    public ApellidosPersonaContacto = '';

    public TelefonoPersonaContacto = '';

    public EmailPersonaContacto = '';

    public Activa: boolean;

    public FechaAlta: Date;

    public FechaBaja: Date | null;

    public Observaciones = '';

    public TwRegCampaniaEntidadAuditoraCollection: RegCampaniaEntidadAuditoraViewModel[];

    public TwRegTecnicoEntidadAuditoraCollection: RegTecnicoEntidadAuditoraViewModel[];
}

export class RegCampaniaEntidadAuditoraViewModel {
    public IdCampania: number;
    public IdCampaniaDescripcion: string;
    public IdRegEntidadAuditora: number;
    public Activa: boolean;
    public FechaAlta: Date;
    public FechaBaja: Date | null;
}

export class RegTecnicoEntidadAuditoraViewModel {
    public IdUsuario: number;
    public NifUsuario = '';
    public NombreUsuario = '';
    public ApellidosUsuario = '';
    public IdRegEntidadAuditora: number;
    public Telefono = '';
    public Ropo = '';
    public Activo: boolean;
    public FechaAlta: Date;
    public FechaBaja: Date | null;
}
